// i18n — Benachrichtigungen / Alarme + Settings-Side-Nav.
//
// WICHTIG: Alarmtyp-Labels liegen unter `notifications.types` als FLACHE Map mit
// gepunkteten Keys (z.B. 'hack_post.country'). Der i18n-Resolver splittet auf '.',
// daher NICHT via t('notifications.types.hack_post.country') auflösen, sondern das
// Parent-Objekt holen: const map = t('notifications.types'); map[typeKey].

export const notificationsMessages = {
  en: {
    settingsNav: {
      general:       'General',
      notifications: 'Notifications',
      apiKeys:       'API Keys',
      generalDesc:       'Profile, appearance, language & security',
      notificationsDesc: 'Alarms, channels & delivery',
      apiKeysDesc:       'Personal API access keys',
    },
    notifications: {
      // Bell / inbox
      bellTitle:     'Notifications',
      bellEmpty:     'No notifications yet.',
      bellViewAll:   'Open settings',
      markAllRead:   'Mark all read',
      markRead:      'Mark as read',
      unreadOne:     '1 unread',
      unreadMany:    '{count} unread',
      justNow:       'just now',

      // Settings page
      pageTitle:     'Notifications & Alarms',
      pageSubtitle:  'Choose which alarms you receive and how they reach you.',

      // Channels
      channels:      'Channels',
      channelBrowser:'Browser',
      channelEmail:  'Email',
      channelBrowserHint: 'Shown in the in-app inbox and as a browser notification.',
      channelEmailHint:   'Also sent to your account email address.',

      // Severity
      minSeverity:   'Minimum severity',
      minSeverityHint:'Only alarms at or above this level are delivered.',

      // Filters
      filterCountries:     'Countries',
      filterCountriesHint: 'Leave empty to match any country.',
      filterSectors:       'Sectors',
      filterSectorsHint:   'Leave empty to match any sector (best-effort match).',

      // Global browser permission block (migrated)
      browserSetup:        'Browser notifications',
      permLabel:           'Browser permission',
      permDesc:            'Required to show desktop notifications outside the app.',
      permBtn:             'Allow',
      permGranted:         'Granted',
      permDenied:          'Blocked',
      permDefault:         'Not requested',
      permDeniedHint:      'Notifications are blocked in your browser settings.',
      unsupported:         'Browser notifications are not available here.',
      testBtn:             'Send test',
      testDesc:            'Send a test notification to check your setup.',
      testBody:            'This is a test notification from secDASH.',

      // Buttons / states
      save:          'Save preferences',
      saved:         'Preferences saved',
      saveFailed:    'Could not save preferences',
      loadFailed:    'Could not load notification settings',
      noTypes:       'No alarm types are available for your account yet.',

      // Partner customer alarm (legacy Enginsight, browser-only)
      partnerAlarmLabel: 'Customer alarms (Enginsight)',
      partnerAlarmDesc:  'Browser notification when one of your managed customers triggers a SIEM alarm.',
      partnerAlarmHint:  'Browser only — saved automatically. Email delivery for customer alarms is coming later.',

      // Severity labels
      sev_critical:  'Critical',
      sev_high:      'High',
      sev_medium:    'Medium',
      sev_low:       'Low',
      sev_info:      'Info',

      // Alarm-type catalog labels (FLAT dotted map — see header note)
      types: {
        'hack_post.country': {
          label: 'New hack post (your countries/sectors)',
          desc:  'A new ransomware/leak post matching the countries or sectors you follow.',
        },
      },
    },
  },

  de: {
    settingsNav: {
      general:       'Grundeinstellungen',
      notifications: 'Benachrichtigungen',
      apiKeys:       'API Keys',
      generalDesc:       'Profil, Darstellung, Sprache & Sicherheit',
      notificationsDesc: 'Alarme, Kanäle & Zustellung',
      apiKeysDesc:       'Persönliche API-Zugriffsschlüssel',
    },
    notifications: {
      // Glocke / Postfach
      bellTitle:     'Benachrichtigungen',
      bellEmpty:     'Noch keine Benachrichtigungen.',
      bellViewAll:   'Einstellungen öffnen',
      markAllRead:   'Alle gelesen',
      markRead:      'Als gelesen markieren',
      unreadOne:     '1 ungelesen',
      unreadMany:    '{count} ungelesen',
      justNow:       'gerade eben',

      // Einstellungs-Seite
      pageTitle:     'Benachrichtigungen & Alarme',
      pageSubtitle:  'Lege fest, welche Alarme du erhältst und auf welchem Weg.',

      // Kanäle
      channels:      'Kanäle',
      channelBrowser:'Browser',
      channelEmail:  'E-Mail',
      channelBrowserHint: 'Erscheint im In-App-Postfach und als Browser-Benachrichtigung.',
      channelEmailHint:   'Wird zusätzlich an deine Konto-E-Mail gesendet.',

      // Schweregrad
      minSeverity:   'Mindest-Schweregrad',
      minSeverityHint:'Es werden nur Alarme ab diesem Niveau zugestellt.',

      // Filter
      filterCountries:     'Länder',
      filterCountriesHint: 'Leer lassen, um alle Länder einzuschließen.',
      filterSectors:       'Branchen',
      filterSectorsHint:   'Leer lassen, um alle Branchen einzuschließen (Best-Effort-Abgleich).',

      // Globaler Browser-Berechtigungsblock (migriert)
      browserSetup:        'Browser-Benachrichtigungen',
      permLabel:           'Browser-Berechtigung',
      permDesc:            'Nötig, um Desktop-Benachrichtigungen außerhalb der App zu zeigen.',
      permBtn:             'Erlauben',
      permGranted:         'Erteilt',
      permDenied:          'Blockiert',
      permDefault:         'Nicht angefragt',
      permDeniedHint:      'Benachrichtigungen sind in deinen Browser-Einstellungen blockiert.',
      unsupported:         'Browser-Benachrichtigungen sind hier nicht verfügbar.',
      testBtn:             'Test senden',
      testDesc:            'Sende eine Test-Benachrichtigung, um die Einrichtung zu prüfen.',
      testBody:            'Dies ist eine Test-Benachrichtigung von secDASH.',

      // Buttons / Zustände
      save:          'Einstellungen speichern',
      saved:         'Einstellungen gespeichert',
      saveFailed:    'Einstellungen konnten nicht gespeichert werden',
      loadFailed:    'Benachrichtigungs-Einstellungen konnten nicht geladen werden',
      noTypes:       'Für dein Konto sind noch keine Alarmtypen verfügbar.',

      // Partner-Kunden-Alarm (Legacy Enginsight, nur Browser)
      partnerAlarmLabel: 'Kunden-Alarme (Enginsight)',
      partnerAlarmDesc:  'Browser-Benachrichtigung, wenn bei einem deiner betreuten Kunden ein SIEM-Alarm auslöst.',
      partnerAlarmHint:  'Nur Browser — wird automatisch gespeichert. E-Mail-Zustellung für Kunden-Alarme folgt später.',

      // Schweregrad-Labels
      sev_critical:  'Kritisch',
      sev_high:      'Hoch',
      sev_medium:    'Mittel',
      sev_low:       'Niedrig',
      sev_info:      'Info',

      // Alarmtyp-Katalog-Labels (FLACHE Punkt-Map — siehe Header-Hinweis)
      types: {
        'hack_post.country': {
          label: 'Neuer Hack-Post (deine Länder/Branchen)',
          desc:  'Ein neuer Ransomware-/Leak-Post passend zu den von dir verfolgten Ländern oder Branchen.',
        },
      },
    },
  },
};
